import React from "react";
import { Link, useLocation } from "react-router-dom";

const NavBar: React.FC = () => {
  const location = useLocation();

  const navItems = [
    { path: "/", label: "首页", icon: "🏠" },
    { path: "/order-cancel", label: "订单取消", icon: "❌" },
    { path: "/order-modify", label: "订单修改", icon: "✏️" },
    { path: "/order-check", label: "订单检查", icon: "✅" },
  ];

  const isActive = (path: string) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="glass-card" style={{ padding: "16px 24px", marginBottom: "20px", borderRadius: "8px" }}>
      <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="btn-primary"
            style={{
              padding: "10px 20px",
              textDecoration: "none",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: isActive(item.path) ? "600" : "400",
              backgroundColor: isActive(item.path) ? "var(--color-primary)" : "transparent",
              color: isActive(item.path) ? "var(--color-background-dark)" : "var(--color-text-primary)",
              border: `1px solid ${isActive(item.path) ? "var(--color-primary)" : "var(--color-border-default)"}`,
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            onMouseEnter={(e) => {
              if (!isActive(item.path)) {
                e.currentTarget.style.borderColor = "var(--color-border-hover)";
                e.currentTarget.style.backgroundColor = "var(--color-background-hover)";
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive(item.path)) {
                e.currentTarget.style.borderColor = "var(--color-border-default)";
                e.currentTarget.style.backgroundColor = "transparent";
              }
            }}
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default NavBar;
